import moment from 'moment';
import { getData } from '@/components/report/service';
import { computeWeightAddZero, getDayOfWeek, getWeekIdx } from '@/utils/query';
import { TableQuery } from '../Filter';
import { enumerateDaysBetweenDates, productItem } from '@/utils';
import { crudRequest } from '@/services/api';
import { initalColumnCof } from './../Columns';
import { GetOrganizationAuth } from '@/services/area';
import { getBelongCenterForOperatingArea } from '@/services/area';

const paramsForm = {
  // provinceArea: undefined, //  { name: '浙江经营本部' },
  productType: [...productItem, '填仓', '整车'],
  // timeType: 3,
  endDate: moment(new Date())
    .subtract(1, 'days')
    .format('YYYY-MM-DD'),
};

export default {
  namespace: 'provincialFlowToWeight',
  state: {
    filter: { ...paramsForm },
    defualtDateFormat: 'YYYY-MM-DD',
    // timeTypeTitle: '时间范围',
    timeTypeTitle: '寄件日期',

    tableItem: [],
    totalRow: {},
    clolumnCofList: [...initalColumnCof],
    weekindexArr: [0, 1, 2, 3, 4, 5, 6],

    tableOffsetHeight: 0,
  },
  effects: {
    *resetSearch(_, { put }) {
      // 重置
      yield put({
        type: 'update',
        payload: {
          filter: { ...paramsForm },
        },
      });
    },
    *getSearchTimeTitle(_, { put }) {
      // 获取筛选时间标题文字
      yield put({
        type: 'update',
        payload: {
          filter: { ...paramsForm },
        },
      });
    },

    *getTableDate(_, { call, put, select }) {
      crudRequest('/api/route/provincialFlowToWeight/search'); // 日志
      let access = yield GetOrganizationAuth();
      let originProvinceArea;
      // 总部
      if (access.isHead) {
        originProvinceArea = [];
      }
      // 营运区
      if (access.isArea) {
        originProvinceArea = access.provinces.map(item => item.name) || [];
      }
      // 分拨
      if (access.isCenter) {
        // 查询分拨所属的营运区
        const area = yield getBelongCenterForOperatingArea([access.name]);
        const areaList = Array.from(area.values());
        originProvinceArea = areaList && areaList.length > 0 ? areaList.map(item => item.provinceAreaName) : [];
      }
      let query = yield select(({ provincialFlowToWeight }) => {
        const filer = provincialFlowToWeight.filter;
        return {
          productType: filer.productType,
          endDate: filer.endDate,
          originProvinceArea: originProvinceArea,
        };
      });

      let startDate; // 开始日期
      let endDate; // 结束日期
      startDate = moment(query.endDate)
        .subtract(6, 'days')
        .format('YYYY-MM-DD 09:00:00');
      endDate = moment(query.endDate).format('YYYY-MM-DD 09:00:00');
      // console.log(startDate,endDate );
      // if (query.timeType === 3) {
      //   // 本周
      //   startDate = moment().startOf('week').format('YYYY-MM-DD 09:00:00');
      // } else if (query.timeType === 2) {
      //   // 上周
      //   startDate = moment().week(moment().week() - 1).startOf('week').format('YYYY-MM-DD 09:00:00');
      // } else if (query.timeType === 1) {
      //   // 上上周
      //   startDate = moment().week(moment().week() - 2).startOf('week').format('YYYY-MM-DD 09:00:00');
      // }
      // endDate = moment(startDate).subtract(-7, 'days').format('YYYY-MM-DD 09:00:00');
      // const timeTypeTitle = `时间范围 (${moment(startDate).format('MM-DD')} ~ ${moment(startDate).subtract(-6, 'days').format('MM-DD')})`

      const timeTypeTitle = `寄件日期 (${moment(startDate).format('MM-DD')} ~ ${moment(
        endDate,
      ).format('MM-DD')})`;
      const baseFilter = TableQuery({
        startDate: startDate,
        endDate: endDate,
        originProvinceArea: query.originProvinceArea,
      });
      const data = yield call(getData, baseFilter[0]);
      // console.log(cloneDeep(data));
      if (data.length > 0) {
        const dateList = enumerateDaysBetweenDates(startDate, endDate);
        // console.log(dateList)
        const weekindexArr = [];
        const clolumnCofList = dateList.map(item => {
          const week = getDayOfWeek(item);
          const weekIndex = getWeekIdx(week);
          weekindexArr.push(weekIndex);
          return {
            // week,
            // date: item,
            // weekIndex,
            title: `${moment(item).format('MM/DD')} ${week}`,
          };
        });
        // .sort((a, b)=> a.weekIndex-b.weekIndex);
        //  console.log(clolumnCofList)

        const resulte = [];
        for (let i = 0; i < dateList.length; i++) {
          const s = dateList[i] + ' 09:00:00';
          const e = moment(moment(s).add(1, 'days')).format('YYYY-MM-DD 09:00:00');
          const filter = TableQuery({
            startDate: s,
            endDate: e,
            productType: query.productType,
            originProvinceArea: query.originProvinceArea,
          });
          const data = yield call(getData, filter[1]);
          resulte[i] = data || [];
        }

        const totalRow = { totalRow: '合计' };
        // console.log(cloneDeep(data));
        // console.log(cloneDeep(resulte))

        data.forEach((item, index) => {
          item.index = index;
          resulte.forEach((item2, index2) => {
            const idx = weekindexArr[index2];
            const obj = item2.find(item3 => item3.originProvinceArea === item.originProvinceArea);
            const calcWeight = obj ? computeWeightAddZero(obj.calcWeight) : '0.00';
            const calcWeightNum = Number(calcWeight);
            item[`calcWeight${idx}`] = calcWeight.toString();
            if (!totalRow[`calcWeight${idx}`]) totalRow[`calcWeight${idx}`] = 0;
            totalRow[`calcWeight${idx}`] += calcWeightNum;
          });
        });

        // data.forEach((item, index) => {
        //   item.index = index;
        //   resulte.forEach((item2, index2) => {
        //     const obj = item2.find(item3 => item3.originProvinceArea === item.originProvinceArea);
        //     const calcWeight = obj ? computeWeightAddZero(obj.calcWeight) : '0.00';
        //     const calcWeightNum = Number(calcWeight);
        //     item[`calcWeight${index2}`] = calcWeight
        //     if (!totalRow[`calcWeight${index2}`])
        //       totalRow[`calcWeight${index2}`] = 0
        //     totalRow[`calcWeight${index2}`] += calcWeightNum
        //   })
        // });
        // console.log({
        //   tableItem: data,
        //   totalRow,
        //   timeTypeTitle: timeTypeTitle,
        //   clolumnCofList,
        //   weekindexArr,
        // })
        yield put({
          type: 'update',
          payload: {
            tableItem: data,
            totalRow,
            timeTypeTitle: timeTypeTitle,
            clolumnCofList,
            weekindexArr,
          },
        });
      }
    },
  },

  reducers: {
    update(state, { payload }) {
      return { ...state, ...payload };
    },
  },
};
